var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.7 200",
    style: {
      enableBackground: "new 0 0 107.7 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.2,57.9L43,197c-1,1.8-9,3-5,3c-0.5,0-1.1-0.1-1.7-0.2c-2.6-0.8-4.2-3.4-3.6-5.9l23.7-97.1L6.8,108.9 c-0.5,0.1-1,0.1-1.4,0.1c-1.3,0-2.8-0.5-3.7-1.3c-1.4-1.2-1.9-3-1.6-4.7L24.3,3.8C24.9,1.6,27,0,29.6,0H69l0,0c3,0,5.4,2.3,5.4,5 c0,0.7-0.2,1.4-0.6,2.2L53.2,62.9l47.6-11.8c0.5-0.1,1-0.2,1.4-0.2c1.6,0,3,0.7,4.1,1.8C107.7,54.1,108,56.1,107.2,57.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/Gym.8a077dd4122712b1d56a6777f8f28fc8.svg";
export { ForwardRef as ReactComponent };